import React from "react";

const useForceUpdate = () => {
    const [, setState] = React.useState(true)
    const forceUpdate = React.useCallback(() => {
        setState(s => !s)
    }, [])
    return forceUpdate
}
export default useForceUpdate;